export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3" style={{ fontFamily: "var(--font-heading)" }}>
          热度榜单
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14">本周最受影迷欢迎的影视内容，热度排行实时更新</p>

        <div className="max-w-3xl mx-auto space-y-3">
          {/* Rank 1 */}
          <div className="flex items-center gap-4 p-4 rounded-xl bg-background-100 border border-primary-200/60 hover:border-primary-300/60 transition-colors cursor-pointer">
            <div className="w-10 h-10 rounded-xl flex items-center justify-center bg-primary-500 text-white font-bold text-lg flex-shrink-0" style={{ fontFamily: "var(--font-heading)" }}>1</div>
            <div className="flex-1 min-w-0">
              <h3 className="text-sm font-semibold text-foreground-900 truncate">暗夜追踪者 · 第三季</h3>
              <p className="text-xs text-foreground-500">悬疑犯罪 · 豆瓣 9.2 · 本周播放量 286万</p>
            </div>
            <div className="flex items-center gap-1 text-primary-500 flex-shrink-0">
              <i className="ri-arrow-up-line text-lg"></i>
              <span className="text-xs font-semibold">TOP 1</span>
            </div>
          </div>

          {/* Rank 2 */}
          <div className="flex items-center gap-4 p-4 rounded-xl bg-background-100 border border-background-200/60 hover:border-accent-300/60 transition-colors cursor-pointer">
            <div className="w-10 h-10 rounded-xl flex items-center justify-center bg-accent-500 text-white font-bold text-lg flex-shrink-0" style={{ fontFamily: "var(--font-heading)" }}>2</div>
            <div className="flex-1 min-w-0">
              <h3 className="text-sm font-semibold text-foreground-900 truncate">山海传说 · 大电影</h3>
              <p className="text-xs text-foreground-500">奇幻动画 · 票房冠军 · 本周播放量 241万</p>
            </div>
            <div className="flex items-center gap-1 text-accent-500 flex-shrink-0">
              <i className="ri-arrow-up-line text-lg"></i>
              <span className="text-xs font-semibold">↑ 3</span>
            </div>
          </div>

          {/* Rank 3 */}
          <div className="flex items-center gap-4 p-4 rounded-xl bg-background-100 border border-background-200/60 hover:border-secondary-300/60 transition-colors cursor-pointer">
            <div className="w-10 h-10 rounded-xl flex items-center justify-center bg-secondary-500 text-white font-bold text-lg flex-shrink-0" style={{ fontFamily: "var(--font-heading)" }}>3</div>
            <div className="flex-1 min-w-0">
              <h3 className="text-sm font-semibold text-foreground-900 truncate">欢乐挑战赛 · 第七季</h3>
              <p className="text-xs text-foreground-500">户外综艺 · 全网热议 · 本周播放量 198万</p>
            </div>
            <div className="flex items-center gap-1 text-foreground-400 flex-shrink-0">
              <i className="ri-subtract-line text-lg"></i>
              <span className="text-xs font-semibold">— 0</span>
            </div>
          </div>

          {/* Rank 4 */}
          <div className="flex items-center gap-4 p-4 rounded-xl bg-background-100 border border-background-200/60 hover:border-background-300/60 transition-colors cursor-pointer">
            <div className="w-10 h-10 rounded-xl flex items-center justify-center bg-foreground-300 text-white font-bold text-lg flex-shrink-0" style={{ fontFamily: "var(--font-heading)" }}>4</div>
            <div className="flex-1 min-w-0">
              <h3 className="text-sm font-semibold text-foreground-900 truncate">星海恋歌</h3>
              <p className="text-xs text-foreground-500">浪漫爱情 · 新剧上榜 · 本周播放量 165万</p>
            </div>
            <div className="flex items-center gap-1 text-accent-500 flex-shrink-0">
              <i className="ri-arrow-up-line text-lg"></i>
              <span className="text-xs font-semibold">↑ 7</span>
            </div>
          </div>

          {/* Rank 5 */}
          <div className="flex items-center gap-4 p-4 rounded-xl bg-background-100 border border-background-200/60 hover:border-background-300/60 transition-colors cursor-pointer">
            <div className="w-10 h-10 rounded-xl flex items-center justify-center bg-foreground-300 text-white font-bold text-lg flex-shrink-0" style={{ fontFamily: "var(--font-heading)" }}>5</div>
            <div className="flex-1 min-w-0">
              <h3 className="text-sm font-semibold text-foreground-900 truncate">地球脉动 · 第三季</h3>
              <p className="text-xs text-foreground-500">自然纪录片 · BBC出品 · 本周播放量 142万</p>
            </div>
            <div className="flex items-center gap-1 text-secondary-500 flex-shrink-0">
              <i className="ri-arrow-down-line text-lg"></i>
              <span className="text-xs font-semibold">↓ 1</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}